
export const uploadsUrl = process.env.CONTENT_URL || 'https://uploads.dupixentvirtualbooth.com/uscongress'
export const contentUrl = `${uploadsUrl}/content`
export const videoContentUrl = `${contentUrl}/videos`
export const pdfContentUrl = `${contentUrl}/pdfs`
export const pdfViewer = `${uploadsUrl}/pdf/web/viewer.html`